import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Dimension, Location } from '@frontend/common';
import type { Stock } from '@frontend/stock/types';

import { SlotStateName } from './slot-state';

export interface Slot {
    number: string | null;
    display: string | null;
    index: number;
    row: number | null;
    column: number | null;
    location: Location | null;
    absolute: Location | null;
    dimension: Dimension | null;
    inner_dimension: Dimension | null;
    type: SlotType | null;
    status: SlotStatus | null;
    state: SlotStateName;
    workflow_id: string | null;

    id: string;
    account_id: string;
    spot_id: string;
    module_id: string;

    update_timestamp: string;
    creation_timestamp: string;
}

export interface CreateSlot {
    number?: string | null;
    display?: string | null;
    index?: number;
    row?: number | null;
    column?: number | null;
    note?: string | null;
    location?: Location | null;
    absolute?: Location | null;
    dimension?: Dimension | null;
    inner_dimension?: Dimension | null;
    type?: SlotType | null;
    drop_station_slot_id?: string | null;
}

export interface UpdateSlot {
    number?: string | null;
    display?: string | null;
    index?: number | null;
    row?: number | null;
    column?: number | null;
    note?: string | null;
    location?: Location | null;
    absolute?: Location | null;
    dimension?: Dimension | null;
    inner_dimension?: Dimension | null;
    type?: SlotType | null;
    drop_station_slot_id?: string | null;
    status?: SlotStatus | null;
    state?: SlotStateName | null;
    workflow_id?: string | null;
}

export enum SlotStatus {
    AVAILABLE = 'available',
    BROKEN = 'broken',
    MERGED = 'merged',
    NON_FUNCTIONAL = 'non_functional',

    /** Legacy only — not accepted on create/update; kept for display of existing data */
    NOT_AVAILABLE = 'not_available'
}

export type SlotListResponse = PaginatedResponse<Slot>;

export interface AvailableSlot extends Slot {
    weight: number;
    matches: number;
    stocks: Stock[];
}

export type AvailableSlotListResponse = PaginatedResponse<AvailableSlot>;

export enum QueryParams {
    account_id = 'account_id',
    SPOT_ID = 'spot_id',
    MODULE_ID = 'module_id',
    FACING = 'facing',
    TYPE = 'type',
    WORKFLOW_ID = 'workflow_id'
}

export type SlotQueryParams = DefaultQueryParams & QueryParams;

export enum SlotType {
    DEFAULT = 'default',
    DROP_STATION = 'drop_station',
    PASS_THROUGH = 'pass_through',
    TERMINAL = 'terminal'
}

export enum SlotFacing {
    INSIDE = 'inside',
    OUTSIDE = 'outside',
    UNSPECIFIED = 'unspecified'
}
